import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
  Component,
  Inject,
  NgZone,
  OnInit,
  PLATFORM_ID,
  Renderer2
} from '@angular/core';
import { Constants } from '@app/constants';

import { AppDynamicsSettingsService } from '../services/app-dynamics.settings.service';

@Component({
  selector: 'app-dynamics-js',
  template: '',
  styles: ['']
})
export class AppDynamicsComponent implements OnInit {
  appDynamicsKey: string;
  appDynamicsScriptURL: string;
  constructor(
    public settingService: AppDynamicsSettingsService,
    @Inject(PLATFORM_ID) private platformId: string,
    @Inject(DOCUMENT) private document: any,
    private ngZone: NgZone,
    private readonly renderer: Renderer2
  ) {
    this.appDynamicsKey = settingService.appDynamicsKey;
    this.appDynamicsScriptURL = settingService.appDynamicsScriptURL;
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.ngZone.runOutsideAngular(() => {
        const script2 = this.renderer.createElement(
          'script'
        ) as HTMLScriptElement;
        script2.type = 'text/javascript';
        const scriptBody = this.renderer.createText(`
                window['adrum-start-time'] = new Date().getTime();
                window['adrum-app-key'] = '${Constants.appConfiguration.appDynamicsKey}';
                (function (config) {
                        config.appkey = '${Constants.appConfiguration.appDynamicsKey}';
                        config.adrumExtUrlHttp = 'http://cdn.appdynamics.com';
                        config.adrumExtUrlHttps = 'https://cdn.appdynamics.com';
                        config.beaconUrlHttp = 'http://pdx-col.eum-appdynamics.com';
                        config.beaconUrlHttps = 'https://pdx-col.eum-appdynamics.com';
                        config.resTiming = { bufSize: 200, clearResTimingOnBeaconSend: true };
                        config.maxUrlLength = 512;
                        config.isZonePromise = true;
                        config.angular = true;
                     })(window['adrum-config'] || (window['adrum-config'] = {}));
                     `);
        this.renderer.appendChild(script2, scriptBody);
        this.renderer.appendChild(
          this.document.getElementsByTagName('head')[0],
          script2
        );

        const script = this.renderer.createElement(
          'script'
        ) as HTMLScriptElement;
        script.src = this.appDynamicsScriptURL;
        script.type = 'text/javascript';
        this.renderer.appendChild(
          this.document.getElementsByTagName('head')[0],
          script
        );
      });
    }
  }
}
